import React from 'react';
interface Props {
  specialInstructions: string;
  setSpecialInstructions: any;
}
function SpecialInstructionsFields({
  specialInstructions,
  setSpecialInstructions,
}: Props) {
  return (
    <div className='row mb-3'>
      <div className='col-sm-12'>
        <textarea
          id='special_instructions'
          className='form-control ubbe-input'
          style={{ height: '230px' }}
          maxLength={150}
          autoComplete='new-password'
          rows={5}
          placeholder='Handling Instructions for the shipment'
          value={specialInstructions}
          onChange={(e) => setSpecialInstructions(e.target.value)}
          onDragStart={() => false}
        ></textarea>
        <div
          className='invalid-feedback'
          id='special_instructions_error'
        >
          Please provide a valid address.
        </div>
      </div>
    </div>
  );
}

export default SpecialInstructionsFields;
